const shared = {
  tr: {
    brand: "Heranida",
    tagline: "Bir bağlantıda tüm anılar",
    hero_title: "Düğün, nişan, kına ve doğum günlerinizi tek bir zarif bağlantıda toplayın",
    hero_sub: "Canlı yayın, OTP korumalı misafir girişi, altın hediye kilidi ve anı arşivi.",
    cta_start: "Ücretsiz Başlat", cta_guest: "Misafir Girişi",
    watch_demo: "Canlı demoyu izle",
    demo_hint: "Kayıt olmadan tam demoyu deneyin",
    demo_badge: "DEMO",
    demo_note: "Bu ekran bir demo — her ziyaretçi kendi oturumunu görür.",
    login: "Giriş Yap", register: "Kayıt Ol", logout: "Çıkış",
    dashboard: "Panelim", create_event: "Etkinlik Oluştur", admin: "Yönetim",
    features: "Özellikler",
    features_items: [
      { t: "Canlı Yayın", d: "YouTube ve Cloudflare Stream ile bekleme/canlı/bitti durumları." },
      { t: "Altın Hediye", d: "90 saniyelik fiyat kilidi, kuyumcu stok kontrolü, integer hassasiyet." },
      { t: "OTP ile Misafir", d: "SMS OTP + etkinlik parolası ile güvenli erişim." },
      { t: "Anı Arşivi", d: "Mesajlar, hediyeler ve yayın kayıtları paylaşılabilir." },
    ],
    step: "Adım", of: "/",
    email: "E-posta", password: "Parola", name: "Ad Soyad",
    submit: "Gönder", save: "Kaydet", continue: "Devam", back: "Geri",
    event_title: "Etkinlik Başlığı", event_type: "Etkinlik Türü",
    starts_at: "Başlangıç", ends_at: "Bitiş", location: "Yer", description: "Açıklama",
    stream_url: "Yayın Bağlantısı (YouTube)", event_password: "Etkinlik Parolası",
    accept_gold: "Altın hediye kabul et", accept_cash: "Nakit hediye kabul et",
    types: { wedding: "Düğün", engagement: "Nişan", henna: "Kına", birthday: "Doğum Günü", other: "Diğer" },
    guests_link: "Misafir Bağlantısı", invite_key: "Davet Anahtarı",
    total_cash: "Toplam Nakit", total_gold: "Toplam Altın", gift_count: "Hediye Sayısı",
    give_gift: "Hediye Ver", cash: "Nakit", gold: "Altın",
    grams: "Miligram (mg)", amount: "Tutar (₺)",
    display_name: "Görünen Ad", anonymous: "Anonim gönder", message: "Mesaj (opsiyonel)",
    live_now: "CANLI", waiting: "Yayın Başlamayı Bekliyor", ended: "Yayın Sona Erdi",
    chat: "Sohbet", say: "Bir şeyler söyle...", wall: "Hediye Duvarı", leaderboard: "Sıralama",
    lock_countdown: "Fiyat kilidi", seconds: "sn",
    confirm_pay: "Ödemeyi Onayla (Demo)", demo_notice: "Demo modu — gerçek ödeme yapılmaz.",
    phone: "Telefon", send_otp: "OTP Gönder", otp_code: "OTP Kodu", verify: "Doğrula",
    enter_password: "Etkinlik parolası", open_event: "Etkinliğe Gir", lang: "Dil",
    viewers: "İzleyici", goal: "Hedef", reset_demo: "Demoyu sıfırla",
    coupon: "Kupon", coupon_desc: "Partner firmalardan hediye kuponu",
    choose_coupon: "Kupon seçin", coupon_from: "Partner",
    message_gift: "Mesaj", message_gift_desc: "Ödemesiz tebrik notu", send_message: "Tebrikle gönder",
    donation: "Bağış", donation_desc: "Kurum adına hayır bağışı",
    choose_cause: "Kurum seçin", donation_to: "Kurum",
    only_note: "Not gönder (ödemesiz)",
    congrats_msgs: [
      "Mutluluklar dileriz, ömür boyu!",
      "Ellerinize sağlık, çok güzel bir gece 🌙",
      "Uzaktan da olsa sizinleyiz kalbimizle.",
      "Bir yastıkta kocayın, ne mutlu size!",
      "Nişan yüzüğü çok yakıştı Ayşe’ciğim.",
      "Yayına bağlandık, tebrikler!",
    ],
    sample_names: ["Ali Y.", "Fatma D.", "Mehmet K.", "Zeynep A.", "Emre S.", "Ayşegül B.", "Onur T.", "Selin M."],
    // Jeweler UI
    jeweler_panel: "Kuyumcu Panelim",
    jeweler: "Kuyumcu", city: "Şehir",
    choose_jeweler: "Anlaşmalı kuyumcu seçin",
    no_jeweler_hint: "Bu etkinlikte fiziksel altın rezervasyonu yapılmaz.",
    orders: "Siparişler", stock: "Stok", prices: "Fiyatlar", summary: "Günlük Özet",
    status_rezerve: "Rezerve", status_hazirlandi: "Hazırlandı", status_teslim_edildi: "Teslim edildi",
    lock_ref: "Kilit No", barcode: "Barkod", delivery_code: "Teslim Kodu",
    prepare: "Hazırla", deliver: "Teslim Et", scan_code: "Kodu okut",
    physical_reservation: "Fiziksel altın rezervasyonu",
    marketplace_note: "Platform altın satmaz; satıcı anlaşmalı kuyumcudur. Heranida aracılık komisyonu alır.",
    total_count: "Toplam", reserved: "Rezerve", available: "Müsait",
    gram_price: "Gram fiyatı (kuruş)", workmanship: "İşçilik (bps)",
    orders_today: "Bugünkü sipariş", grams_today: "Toplam gram",
    payable: "Ödenecek", commission: "Komisyon",
    add_jeweler: "Kuyumcu Ekle",
    performance: "Performans",
    avg_prep: "Ortalama hazırlama",
    delivery_rate: "Teslim oranı",
  },
};
// Reuse TR as English scaffold with translated strings (keys balanced)
const _tr = shared.tr;
const en = {
  ..._tr,
  tagline: "All memories in one link",
  hero_title: "Bring your wedding, engagement, henna and birthdays together in one elegant link",
  hero_sub: "Live streaming, OTP-protected guest access, gold price lock and memory archive.",
  cta_start: "Start Free", cta_guest: "Guest Access",
  watch_demo: "Watch live demo",
  demo_hint: "Try the full demo without signing up",
  demo_note: "This is a demo — every visitor sees an isolated session.",
  login: "Sign In", register: "Sign Up", logout: "Logout",
  dashboard: "My Panel", create_event: "Create Event", admin: "Admin",
  features: "Features",
  features_items: [
    { t: "Live Stream", d: "YouTube + Cloudflare Stream states: waiting/live/ended." },
    { t: "Gold Gifts", d: "90-sec price lock with jeweler stock and integer precision." },
    { t: "Guest OTP", d: "SMS OTP and event password for safe entry." },
    { t: "Memory Archive", d: "Messages, gifts and recordings, shareable." },
  ],
  step: "Step", of: "of",
  email: "Email", password: "Password", name: "Full Name",
  submit: "Submit", save: "Save", continue: "Continue", back: "Back",
  event_title: "Event Title", event_type: "Event Type",
  starts_at: "Starts", ends_at: "Ends", location: "Location", description: "Description",
  stream_url: "Stream URL (YouTube)", event_password: "Event Password",
  accept_gold: "Accept gold gifts", accept_cash: "Accept cash gifts",
  types: { wedding: "Wedding", engagement: "Engagement", henna: "Henna", birthday: "Birthday", other: "Other" },
  guests_link: "Guest Link", invite_key: "Invite Key",
  total_cash: "Total Cash", total_gold: "Total Gold", gift_count: "Gift Count",
  give_gift: "Give Gift", cash: "Cash", gold: "Gold",
  grams: "Milligrams (mg)", amount: "Amount (₺)",
  display_name: "Display Name", anonymous: "Send anonymously", message: "Message (optional)",
  live_now: "LIVE", waiting: "Waiting for Stream", ended: "Stream Ended",
  chat: "Chat", say: "Say something...", wall: "Gift Wall", leaderboard: "Leaderboard",
  lock_countdown: "Price lock", seconds: "s",
  confirm_pay: "Confirm Payment (Demo)", demo_notice: "Demo mode — no real payment is captured.",
  phone: "Phone", send_otp: "Send OTP", otp_code: "OTP Code", verify: "Verify",
  enter_password: "Event password", open_event: "Enter Event", lang: "Language",
  viewers: "Viewers", goal: "Goal", reset_demo: "Reset demo",
  coupon: "Coupon", coupon_desc: "Partner vouchers",
  choose_coupon: "Choose a coupon", coupon_from: "Partner",
  message_gift: "Message", message_gift_desc: "No-payment congratulation note", send_message: "Send message",
  donation: "Donation", donation_desc: "Charity donation on behalf of the couple",
  choose_cause: "Choose a cause", donation_to: "Cause",
  only_note: "Send a note (no payment)",
  congrats_msgs: [
    "Wishing you a lifetime of happiness!",
    "Beautiful evening — congratulations 🌙",
    "With you in spirit from afar.",
    "May you grow old together!",
    "The ring suits you perfectly, Ayşe.",
    "Live-tuned in, congrats!",
  ],
  sample_names: ["Ali Y.", "Fatma D.", "Mehmet K.", "Zeynep A.", "Emre S.", "Ayşegül B.", "Onur T.", "Selin M."],
  jeweler_panel: "Jeweler Panel", jeweler: "Jeweler", city: "City",
  choose_jeweler: "Choose a partner jeweler",
  no_jeweler_hint: "No physical gold reservation will be made for this event.",
  orders: "Orders", stock: "Stock", prices: "Prices", summary: "Daily Summary",
  status_rezerve: "Reserved", status_hazirlandi: "Prepared", status_teslim_edildi: "Delivered",
  lock_ref: "Lock Ref", barcode: "Barcode", delivery_code: "Delivery Code",
  prepare: "Prepare", deliver: "Deliver", scan_code: "Scan code",
  physical_reservation: "Physical gold reservation",
  marketplace_note: "Platform doesn't sell gold; the partner jeweler does. Heranida acts as intermediary and takes a commission.",
  total_count: "Total", reserved: "Reserved", available: "Available",
  gram_price: "Gram price (kuruş)", workmanship: "Workmanship (bps)",
  orders_today: "Orders today", grams_today: "Grams total",
  payable: "Payable", commission: "Commission",
  add_jeweler: "Add Jeweler",
  performance: "Performance",
  avg_prep: "Avg. prep",
  delivery_rate: "Delivery rate",
};
const de = { ..._tr,
  tagline: "Alle Erinnerungen in einem Link",
  hero_title: "Hochzeit, Verlobung, Henna und Geburtstage in einem eleganten Link",
  hero_sub: "Livestream, OTP-Gast, Goldpreis-Lock und Erinnerungsarchiv.",
  cta_start: "Kostenlos starten", cta_guest: "Gastzugang",
  watch_demo: "Live-Demo ansehen",
  demo_note: "Dies ist eine Demo — jeder Besucher hat eine eigene Sitzung.",
  login: "Anmelden", register: "Registrieren", logout: "Abmelden",
  dashboard: "Mein Panel", create_event: "Event erstellen", admin: "Admin",
  types: { wedding: "Hochzeit", engagement: "Verlobung", henna: "Henna", birthday: "Geburtstag", other: "Andere" },
  give_gift: "Geschenk", cash: "Bargeld", gold: "Gold",
  coupon: "Gutschein", message_gift: "Nachricht", donation: "Spende",
  jeweler_panel: "Juwelier-Panel", jeweler: "Juwelier",
  choose_jeweler: "Partner-Juwelier wählen",
  marketplace_note: "Die Plattform verkauft kein Gold — der Verkäufer ist der Partner-Juwelier. Heranida vermittelt und erhält Provision.",
  orders: "Bestellungen", stock: "Bestand", prices: "Preise", summary: "Tagesübersicht",
  prepare: "Vorbereiten", deliver: "Ausliefern", scan_code: "Code scannen",
  add_jeweler: "Juwelier hinzufügen",
};
const ar = { ..._tr,
  brand: "هيرانيدا",
  tagline: "كل الذكريات في رابط واحد",
  hero_title: "اجمع الزفاف والخطوبة والحناء وأعياد الميلاد في رابط أنيق",
  hero_sub: "بث مباشر، دخول OTP، تثبيت سعر الذهب، وأرشيف الذكريات.",
  cta_start: "ابدأ مجاناً", cta_guest: "دخول الضيوف",
  watch_demo: "شاهد العرض المباشر",
  demo_badge: "عرض",
  demo_note: "هذا عرض توضيحي — لكل زائر جلسة مستقلة.",
  login: "دخول", register: "تسجيل", logout: "خروج",
  dashboard: "لوحتي", create_event: "إنشاء فعالية", admin: "الإدارة",
  types: { wedding: "زفاف", engagement: "خطوبة", henna: "حنّة", birthday: "عيد ميلاد", other: "أخرى" },
  give_gift: "قدّم هدية", cash: "نقد", gold: "ذهب",
  coupon: "قسيمة", message_gift: "رسالة", donation: "تبرع",
  jeweler_panel: "لوحة المجوهرات", jeweler: "المجوهرات",
  choose_jeweler: "اختر شريك مجوهرات",
  marketplace_note: "المنصة لا تبيع الذهب — البائع هو شريك المجوهرات. تعمل هيرانيدا كوسيط وتأخذ عمولة.",
  orders: "الطلبات", stock: "المخزون", prices: "الأسعار", summary: "ملخص اليوم",
  prepare: "تجهيز", deliver: "تسليم", scan_code: "امسح الرمز",
  add_jeweler: "أضف مجوهرات",
};
const dict = { tr: shared.tr, en, de, ar };
export default dict;
export const LANGS = [
  { code: "tr", label: "Türkçe" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "ar", label: "العربية" },
];
